"use client";

import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 720px)";

export function useMobile(): boolean {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    setMobile(mql.matches);
    const handler = (event: MediaQueryListEvent) => setMobile(event.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return mobile;
}
